<div *ngIf="loader1" class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
<header id="main-menu-header" class="header fixed-top d-flex align-items-center">
	<div class="d-flex align-items-center justify-content-between">
		<a [routerLink]="[homeUrl]" class="logo d-flex align-items-center">
			<img src="../assets/img/3Cube-dark.png" alt="">
		</a>
	</div>
	<mat-toolbar style="background: none;">
		<a mat-button [routerLink]="[homeUrl]" [routerLinkActive]="'menu-active'" matTooltip="Home">
			<fa-icon [icon]="['fas','home']" class="fs-16"></fa-icon>
		</a>
		<a mat-button [routerLinkActive]="'menu-active'" [routerLink]="['/comp/list-appointment']"
			matTooltip="Appointments">
			<fa-icon [icon]="['fas','calendar-alt']" class="fs-16"></fa-icon>
		</a>
		<span class="fs-16 ms-2">{{user?.company_name}}</span>
	</mat-toolbar>
	<nav class="header-nav ms-auto">
		<ul class="d-flex align-items-center">
			<li class="nav-item dropdown pe-3">
				<a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
					<img src="../assets/img/profile-img.png" alt="Profile" class="rounded-circle">
					<span class="d-none d-md-block dropdown-toggle ps-2">
						{{user?.first_name}} {{user?.last_name}}
					</span>
				</a>
				<ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
					<li class="dropdown-header">
						<h6>
							{{user?.first_name}} {{user?.last_name}}
						</h6>
					</li>
					<li>
						<hr class="dropdown-divider">
					</li>
					<li>
						<a class="dropdown-item d-flex align-items-center" style="cursor: pointer;"
							(click)="logoutUser()">
							<i class="bi bi-box-arrow-right"></i>
							<span>Sign Out</span>
						</a>
					</li>
				</ul>
			</li>
		</ul>
	</nav>
</header>
<main id="page-content-container-common" class="main" [@routeAnimations]="prepareRoute(o)">
	<router-outlet #o="outlet"></router-outlet>
</main>
<br />
<footer id="footer" class="footer fixed-bottom bg-light">
	<div class="row g-0">
		<div class="col"></div>
		<div class="col">
			<div class="copyright">
				&copy; Copyright <strong><span>3CubeMedicare</span></strong>.
				&nbsp;All Rights Reserved
			</div>
		</div>
		<div class="col">
			<fa-icon *ngIf="showScrollBtn" [icon]="['fas', 'angle-double-up']" (click)="scrollToTop()"
				matTooltip="Scroll to top" [matTooltipPosition]="'left'" class="float-end me-2" role="button"></fa-icon>
		</div>
	</div>
</footer>